import React from 'react';
import { useDispatch } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import { TRADE_ACADEMY } from '../AppsData.js';
import { toggleEnabledWithEntity } from '../Redux/Actions.js';

const TradeAcademyButton = () => {
  const dispatch = useDispatch();

  const onToggleAppEnabled = () => dispatch(toggleEnabledWithEntity(TRADE_ACADEMY));

  const onVisitClick = () => {
    onToggleAppEnabled();
    window.open('https://www.tradeacademy.com/?utm_source=housecallpro&utm_medium=in-product&utm_campaign=hvac-app-card&mc=housecallpro&msc=hvac-app-card', '_blank');
  };

  return (
    <Button
      variant='contained' color="primary"
      style={{color: '#ffffff', width: '100%'}}
      onClick={onVisitClick}
    >
      VISIT
    </Button>
  );
};

export default TradeAcademyButton;
